export interface IHeaderBidderConfigPipelineNodeProvenance {
  id: string;
  name: string;
}

const options: IHeaderBidderConfigPipelineNodeProvenance[] = [
  {
    id: 'D',
    name: 'Direct',
  },
  {
    id: 'P',
    name: 'Programmatic',
  },
];

export default options;
